module.exports = __webpack_public_path__ + "static/media/large-file-in-progress.ccadd0e8.svg";